import type { GraphQLTypes, InputType } from '@zeus/index'
import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

const documentFields = {
  id: true,
  createdAt: true,
  title: true,
  fileName: true,
  sizeBytes: true,
  requiredBeforeStart: true,
  sessionId: true,
  sessionName: true,
  acknowledgementCount: true,
} as const

/** Documents remis aux apprenants (#326), gérés par l'admin. Le dépôt passe par `POST /documents`. */
export const GQL_TRAINING_DOCUMENTS = typedGql('query', { scalars })({ trainingDocuments: documentFields })

export const GQL_UPDATE_TRAINING_DOCUMENT = typedGql('mutation', { scalars })({
  updateTrainingDocument: [{ input: $('input', 'UpdateTrainingDocumentInput!') }, documentFields],
})

export const GQL_ARCHIVE_TRAINING_DOCUMENT = typedGql('mutation', { scalars })({
  archiveTrainingDocument: [{ id: $('id', 'ID!') }, true],
})

export const GQL_DOCUMENT_ACKNOWLEDGEMENTS = typedGql('query', { scalars })({
  documentAcknowledgements: [{ documentId: $('documentId', 'ID!') }, { at: true, name: true, email: true }],
})

/** L'apprenant déclare avoir pris connaissance d'un document (#326). */
export const GQL_ACKNOWLEDGE_DOCUMENT = typedGql('mutation', { scalars })({
  acknowledgeDocument: [{ id: $('id', 'ID!') }, true],
})

export type TrainingDocument = InputType<GraphQLTypes['TrainingDocumentModel'], typeof documentFields, typeof scalars>

/** Route du fichier d'un document, pour l'admin comme pour l'apprenant. */
export function documentFilePath(id: string): string {
  return `/documents/${id}/file`
}
